// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-tag.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-tag-container-height=2rem] - height of container
   */
  --sh-tag-container-height: 2rem;
  /* 
   * @cssprop [--sh-tag-wrapper-border=0.0625rem] - border of tag wrapper
   */
  --sh-tag-wrapper-border: 0.0625rem;
  /* 
   * @cssprop [--sh-tag-padding=0 0.5rem] - left and right padding of tag
   */
  --sh-tag-padding: 0 0.5rem;
  /* 
   * @cssprop [--sh-tag-label-line-height=2rem] - line height of tag label
   */
  --sh-tag-label-line-height: 2rem;
  /* 
   * @cssprop [--sh-tag-icon-padding=0.5rem] - padding of the icon
   */
  --sh-tag-icon-padding: 0.5rem;
  /* 
   * @cssprop [--sh-tag-border-radius=0.125rem] - border radius
   */
  --sh-tag-border-radius: 0.125rem;
}

:host {
  height: var(--sh-tag-container-height);
  overflow-y: hidden;
  flex-direction: row;
  cursor: pointer;
  outline: 0;
  display: block;
  flex-shrink: 0;
}

.tag-wrapper {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  width: -ms-fit-content;
  width: -moz-fit-content;
  height: 100%;
  border: var(--sh-tag-wrapper-border) solid rgba(var(--ui-1), var(--opacity-5));
  box-sizing: border-box;
  border-radius: var(--sh-tag-border-radius);
  padding: var(--sh-tag-padding);
  transition: var(--transition-time) all ease-in-out;
}

:host([removable]) .tag-wrapper {
  padding-right: 0;
  justify-content: flex-end;
}

:host([selectable][active]) .tag-wrapper {
  background-color: rgba(var(--ui-1), var(--opacity-7));
}

:host(:hover) .tag-wrapper,
:host(.hover) .tag-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-4));
}

.tag-wrapper .tag-label {
  font: var(--body-1);
  color: var(--text-primary);
  line-height: var(--sh-tag-label-line-height);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: -webkit-fill-available;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}

.tag-wrapper sh-icon {
  padding: var(--sh-tag-icon-padding);
}

:host([removable]) .tag-wrapper .tag-label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

:host([disabled]) {
  pointer-events: none;
}

:host([disabled]) .tag-wrapper {
  border-color: rgba(var(--ui-1), var(--opacity-7));
}

:host([disabled]) .tag-wrapper .tag-label {
  color: rgba(var(--ui-1), var(--opacity-5));
}

:host([disabled]) sh-icon {
  color: rgba(var(--ui-1), var(--opacity-6));
}`;